<template>
    <div class="container-fluid page-product-edit">
        <div class="loading" v-if="loading">Cargando página&#8230;</div>

        <!-- HEADER -->
        <div class="view-header">
            <div class="view-header__main">
                <div class="view-header__info">
                    <h1 class="view-header__title">
                        {{title}}
                        <span v-if="productId && product.name" class="view-header__title-suffix">{{product.name}}</span>
                    </h1>
                    <p class="view-header__subtitle">Modificá la información y configuración del producto. Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
                </div>
                <div class="view-header__actions">
                    <button type="button" class="view-header__btn" @click="$router.push('/inventario/productos')">Cancelar</button>
                    <button type="submit" class="view-header__btn view-header__btn--primary" :disabled="disabledsave>0" @click="prepareSend()">
                        <i class="bi bi-check-lg"></i> Guardar producto
                    </button>
                </div>
            </div>
        </div>

        <!-- TABS -->
        <ul class="nav product-tabs">
            <li class="nav-item">
                <a class="nav-link" href="#" :class="{active: activeTab==0}" @click.prevent="activeTab=0">
                    <i class="fa fa-box"></i>
                    General
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#" :class="{active: activeTab==1}" @click.prevent="activeTab=1">
                    <i class="fa fa-dollar-sign"></i>
                    Precios y listas
                </a>
            </li>
            <!-- Variables sin terminar
            <li class="nav-item" v-if="config.ecommerce" v-show="product.ecom_active">
                <a class="nav-link" href="#" :class="{active: activeTab==2}" @click.prevent="activeTab=2">
                    <i class="fa fa-store"></i>
                    Variantes
                </a>
            </li>
            -->
        </ul>

        <!-- TAB: GENERAL -->
        <div v-show="activeTab==0" class="row">

            <!-- LEFT COLUMN -->
            <div class="col-md-9">

                <!-- DATOS GENERALES -->
                <div class="form-card">
                    <div class="form-card__header">
                        <h6 class="form-card__title"><i class="bi bi-box-seam"></i> Datos generales</h6>
                    </div>
                    <div class="form-card__body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label form-card__label--required">Nombre</label>
                                    <input v-model="product.name" @input="clearError('name')" class="form-control" :class="{'is-invalid': errors.name}" placeholder="Nombre del producto..."/>
                                    <div v-if="errors.name" class="invalid-feedback d-block">{{errors.name}}</div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-card__field">
                                    <label class="form-card__label">Tipo</label>
                                    <select v-model="product.type" class="form-control">
                                        <option value="PRODUCT">PRODUCTO</option>
                                        <option value="SERVICE">SERVICIO</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-card__field">
                                    <label class="form-card__label">Tipo de IVA</label>
                                    <select v-model="product.iva" class="form-control">
                                        <option value="">Sin IVA</option>
                                        <option value="2.5">IVA 2.5%</option>
                                        <option value="5">IVA 5%</option>
                                        <option value="10.5">IVA 10,5%</option>
                                        <option value="21">IVA 21%</option>
                                        <option value="27">IVA 27%</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-card__field">
                                    <label class="form-card__label">Marca</label>
                                    <select v-model="product.brand_id" class="form-control select-search">
                                        <option :value="null">Ninguna</option>
                                        <option v-for="brand in brands" :key='brand.id' :value="brand.id">{{brand.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-card__field">
                                    <label class="form-card__label">Unidad de medida</label>
                                    <select v-model="product.unit" class="form-control">
                                        <option value="U">Unidad</option>
                                        <option value="Kg">Kilogramo</option>
                                        <option value="Tn">Tonelada</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="!isService">
                                <div class="form-card__field">
                                    <label class="form-card__label">Proveedores</label>
                                    <treeselect class="multiList" v-model="product.prov_linked"
                                                :options="providersList"
                                                :multiple="true"
                                                :flat="true"
                                                :autoSelectAncestors="true"
                                                :autoDeselectDescendants="true"
                                                :open-on-click="true"
                                                :append-to-body="true"
                                                value-consists-of="ALL_WITH_INDETERMINATE"
                                                />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label">Categorías</label>
                                    <treeselect class="multiList" v-model="product.cat_linked"
                                        :options="categoriesList"
                                        :multiple="true"
                                        :flat="true"
                                        :autoSelectAncestors="true"
                                        :autoDeselectDescendants="true"
                                        :open-on-click="true"
                                        :append-to-body="true"
                                        value-consists-of="ALL_WITH_INDETERMINATE"
                                        />
                                </div>
                            </div>
                            <div class="col-md-3" v-if="!isService">
                                <div class="form-card__field">
                                    <label class="form-card__label">Stock mínimo</label>
                                    <input
                                    v-model.number="product.stock_minimum"
                                    @wheel="$event.target.blur()"
                                    type="number"
                                    min="1"
                                    class="form-control"
                                    placeholder="0"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3" v-if="!initial && stockLoaded && !isService">
                                <div class="form-card__field">
                                    <label class="form-card__label">Stock actual</label>
                                    <input :value="`${stockCurrent} ${product.unit}`" disabled class="form-control"/>
                                    <small class="form-card__hint">{{ stockCurrentWarehouse ? `Depósito: ${stockCurrentWarehouse}` : 'Stock del depósito de tu sucursal.' }}</small>
                                </div>
                            </div>
                            <div class="col-md-3" v-if="initial && !isService">
                                <div class="form-card__field">
                                    <label class="form-card__label">Stock inicial</label>
                                    <input v-model.number="product.stock_initial" @wheel="$event.target.blur()" type="number" min="0" class="form-control"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CODIGOS DEL PRODUCTO -->
                <div class="form-card">
                    <div class="form-card__header">
                        <h6 class="form-card__title"><i class="bi bi-upc-scan"></i> Códigos del producto</h6>
                    </div>
                    <div class="form-card__body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label">Código de barras</label>
                                    <input v-model="product.barcode" placeholder="Ej: 7790250000358" @input="handleInput" class="form-control"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label">Código interno</label>
                                    <div class="d-flex align-items-center">
                                        <input v-model="product.code" placeholder="Ej: 2121" @keydown.enter.prevent class="form-control"/>
                                        <button type="button" class="form-card__btn form-card__btn--primary ml-2" @click="suggestCode()">Sugerir</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label">Código de fábrica</label>
                                    <input v-model="product.manufacturer_code" placeholder="Ej: NP21JPN" class="form-control"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-card__field">
                                    <label class="form-card__label">Código de despacho</label>
                                    <input v-model="product.dispatch_code" placeholder="Ej: 99 001 IC09 065099 L" class="form-control"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STOCK POR DEPOSITO (multi depósito) -->
                <div class="form-card" v-if="!initial && stockByWarehouse.length>1 && !isService">
                    <div class="form-card__header">
                        <h6 class="form-card__title"><i class="bi bi-houses"></i> Stock por depósito</h6>
                    </div>
                    <div class="form-card__body">
                        <div class="table-responsive">
                            <table class="table stock-wh-table">
                                <thead>
                                    <tr>
                                        <th v-for="w in stockByWarehouse" :key="w.id">{{w.name}}</th>
                                        <th class="stock-wh__total">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td v-for="w in stockByWarehouse" :key="w.id">{{w.stock}} {{product.unit}}</td>
                                        <td class="stock-wh__total">{{stockTotal}} {{product.unit}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <small class="form-card__hint">Se calcula desde los movimientos de stock.</small>
                    </div>
                </div>

            </div>

            <!-- RIGHT COLUMN -->
            <div class="col-md-3">
                <div class="form-card">
                    <div class="form-card__header">
                        <h6 class="form-card__title"><i class="bi bi-shop"></i> Tienda / E-commerce</h6>
                    </div>
                    <div class="form-card__body">
                        <div class="form-card__field" v-if="config.ecommerce">
                            <label class="toggle-switch">
                                <input v-model="product.ecom_active" type="checkbox">
                                <span class="toggle-switch__slider"></span>
                                <span class="toggle-switch__text">Activar producto para E-commerce</span>
                            </label>
                        </div>

                        <div class="form-card__field">
                            <label class="form-card__label">Imagen del producto</label>
                            <uploadimage :imagesprev="product.images" @imageschanged="setimages" @processing="(v) => disabledsave+=v"></uploadimage>
                        </div>

                        <div class="form-card__field">
                            <label class="form-card__label">Descripción</label>
                            <textarea rows="4" class="form-control" v-model="product.description" placeholder="Descripción corta del producto para la tienda..."></textarea>
                            <small class="form-card__hint">Detalle el producto en un breve texto que se mostrará en la tienda.</small>
                        </div>

                        <!-- TODO: pendiente de implementación
                        <div class="form-card__field">
                            <label class="form-card__label">Etiqueta de promoción</label>
                            <input class="form-control" placeholder="Texto de etiqueta... 40% off"/>
                            <small class="form-card__hint">Texto breve que se mostrará en los productos de la tienda.</small>
                        </div>

                        <div class="form-card__field" v-if="config.ecommerce">
                            <div class="d-flex align-items-center">
                                <label class="toggle-switch mr-2">
                                    <input type="checkbox">
                                    <span class="toggle-switch__slider"></span>
                                    <span class="toggle-switch__text">Descuento</span>
                                </label>
                                <input v-model="product.ecom_active" type="number" class="form-control ml-2" style="max-width: 100px;" placeholder="%"/>
                            </div>
                        </div>
                        -->

                    </div>
                </div>
            </div>
        </div>

        <!-- TAB: PRECIOS Y LISTAS -->
        <div v-show="activeTab==1" class="form-card">
            <div class="form-card__header">
                <h6 class="form-card__title"><i class="bi bi-cash-coin"></i> Listas de precios</h6>
            </div>
            <div class="form-card__body">

                <!-- CONFIGURACION -->
                <div class="col-12 text-left mb-4">
                    <label class="toggle-switch">
                        <input v-model="product.editable" type="checkbox">
                        <span class="toggle-switch__slider"></span>
                        <span class="toggle-switch__text">Permitir edición de precio en el Punto de Venta</span>
                    </label>
                </div>

                <!-- BASES DE CALCULO -->
                <div class="form-card__section">
                    <label class="form-card__label mb-2">Bases de cálculo</label>
                    <div class="row">
                        <v-guard :permissions="['PRODUCTO_VER_PRECIO_COSTO']">
                            <div class="col-md-2">
                                <div class="form-card__field">
                                    <label class="form-card__label form-card__label--required">Costo</label>
                                    <div @keydown.enter.prevent :class="{'field-invalid': errors.base_price}">
                                        <input v-if="!$permitsAny(['PRODUCTO_CAMBIAR_PRECIO_COSTO'])" disabled :value="product.base_price" class="form-control"/>
                                        <currency v-else v-model.number="product.base_price" @input="clearError('base_price')" :currency="product.currency" :selective="true" v-on:change="changeCurrency"/>
                                    </div>
                                    <div v-if="errors.base_price" class="invalid-feedback d-block">{{errors.base_price}}</div>
                                    <small class="form-card__hint">Precio que pagás por el producto.</small>
                                </div>
                            </div>
                        </v-guard>
                        <div class="col-md-2 text-left">
                            <div class="form-card__field">
                                <label class="form-card__label">Valor del dólar</label>
                                <div @keydown.enter.prevent>
                                    <currency v-model.number="product.exchange_rate" :currency="product.currency" :selective="true" v-on:change="changeCurrency"/>
                                </div>
                                <small class="form-card__hint">Guarde el valor del dólar a la fecha.</small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- LISTAS CONFIGURADAS -->
                <div class="form-card__section">
                    <label class="form-card__label mb-2">Listas configuradas</label>

                    <div class="table-responsive">
                        <table class="table price-lists-table">
                            <thead>
                                <tr>
                                    <th class="price-lists-table__col-name">Lista</th>
                                    <th class="price-lists-table__col-price">Precio</th>
                                    <th class="price-lists-table__col-meta">Ganancia</th>
                                    <th class="price-lists-table__col-meta">Modificado</th>
                                    <th class="price-lists-table__col-actions"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="price in pricesList" :key="price.id" @keydown.enter.prevent>
                                    <td class="price-lists-table__col-name">
                                        <strong>{{price.name}}</strong>
                                    </td>
                                    <td class="price-lists-table__col-price">
                                        <template v-if="pricelistToEdit !== price.id">
                                            <input
                                                :disabled="!$permitsAny(['PRODUCTO_CAMBIAR_PRECIOS'])"
                                                v-model.number="product.prices[price.id]"
                                                @input="clearError('price_' + price.id)"
                                                @wheel="$event.target.blur()"
                                                type="number"
                                                class="form-control"
                                                :class="{'is-invalid': errors['price_' + price.id]}"
                                                step="0.01"
                                                placeholder="$"
                                            />
                                            <div v-if="errors['price_' + price.id]" class="invalid-feedback d-block">{{errors['price_' + price.id]}}</div>
                                        </template>
                                        <template v-else>
                                            <div class="input-group">
                                                <input
                                                    :value="Math.round(Number(valueOverCost)) || ''"
                                                    @input="valueOverCost = parseInt($event.target.value, 10) || 0"
                                                    @wheel="$event.target.blur()"
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Ej: 30"
                                                    step="1"
                                                    min="0"
                                                />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">%</span>
                                                </div>
                                            </div>
                                            <small class="form-card__hint">Ingresá el % de ganancia sobre el costo.</small>
                                        </template>
                                    </td>
                                    <td class="price-lists-table__col-meta">
                                        <span v-if="pricelistToEdit !== price.id" class="text-muted">{{getEarningPercent(price.id)}} %</span>
                                    </td>
                                    <td class="price-lists-table__col-meta">
                                        <span v-if="pricelistToEdit !== price.id" class="text-muted">{{getLastUpdate(price.id)}}</span>
                                    </td>
                                    <td class="price-lists-table__col-actions">
                                        <button v-if="pricelistToEdit !== price.id" type="button" class="form-card__btn" @click="setPricelistToEdit(price.id)" title="Calcular % sobre costo">
                                            <i class="bi bi-percent"></i>
                                        </button>
                                        <div v-else class="d-flex gap-1">
                                            <button type="button" class="form-card__btn form-card__btn--primary" @click="calculateIncrease(price)">Aplicar</button>
                                            <button type="button" class="form-card__btn" @click="cancelIncrease()">Cancelar</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>

        <!-- TAB: E-COMMERCE (atributos y variantes) -->
        <div class="form-card" v-if="config.ecommerce" v-show="activeTab==2">
            <div class="form-card__header">
                <h6 class="form-card__title"><i class="bi bi-tags"></i> Atributos</h6>
                <button type="button" class="form-card__btn form-card__btn--primary" @click="openAttsModal">
                    <i class="bi bi-plus-lg"></i> Asignar atributos
                </button>
            </div>
            <div class="form-card__body">
                <p class="text-muted mb-3" style="font-size: 13px;">
                    Definí qué dimensiones (color, talle, material, etc.) tiene este producto.
                </p>

                <!-- Lista de grupos asignados -->
                <div v-for="(group, index) in attGroups" :key="index" class="att-group">
                    <div class="att-group__header">
                        <span class="att-group__title">{{group.name}}</span>
                    </div>
                    <div class="att-group__body">
                        <div class="att-list">
                            <span v-for="att in group.attributes" :key="att.id" class="att-item att-item--readonly">
                                <span v-if="group.class=='color'" class="dot" :style="getHexa(att.data)" :title="att.name"></span>
                                <small v-if="group.class=='color'">{{att.name}}</small>
                                <span v-if="group.class=='tag'" class="tag">{{att.name}}</span>
                                <span v-if="group.class=='list'">{{att.name}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="att-group__footer">
                        <button type="button" class="att-group__delete" @click="attGroupRemove(group.id)">
                            <i class="bi bi-x-lg"></i> Quitar del producto
                        </button>
                    </div>
                </div>

                <!-- Empty state -->
                <div v-if="!attGroups || attGroups.length === 0" class="att-empty att-empty--compact">
                    <i class="bi bi-tags att-empty__icon"></i>
                    <p class="att-empty__text">
                        Aún no asignaste atributos a este producto.
                    </p>
                </div>
            </div>
            <!-- TODO: bloque de Variantes pendiente de terminar (UI nueva + lógica)
            <div class="form-card__header">
                <h6 class="form-card__title"><i class="bi bi-grid-3x3-gap"></i> Variantes</h6>
            </div>
            <div class="form-card__body">
                <div v-if="variantList.length<1 && newVariants.length<1">
                    <div v-if="attGroups.length<1" class="text-muted">
                        Asigne atributos al producto para comenzar a crear variantes.
                    </div>
                    <div v-else>
                        No hay variantes para este producto, <a @click="openVariantsModal" class="link">puede comenzar a añadirlas</a>
                    </div>
                </div>
                <div v-else>
                    <div class="mb-3">
                        <a @click="openVariantsModal" class="link">Agregar nueva variante &gt;&gt;</a>
                    </div>
                    <div v-if="variantList.length>0">
                        <label>Variantes existentes</label>
                        <div class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th class="col-md-1">ID</th>
                                    <th class="col-md-7"><span>ATRIBUTOS</span></th>
                                    <th class="col-md-2"><span>STOCK</span></th>
                                    <th class="col-md-2"><span></span></th>
                                </tr>
                                <tr v-for="variant in variantList" :key='variant.id'>
                                    <td class="col-md-1">{{variant.id}}</td>
                                    <td class="col-md-7">
                                        <span>{{listAtts(variant.attList)}}</span>
                                    </td>
                                    <td class="col-md-2">
                                        <input type="number" class="form-control stockbox" v-model="variant.stock">
                                    </td>
                                    <td class="col-md-2 form-inline">
                                        <span @click="updateVariant(variant)" class="glyphicon glyphicon-ok-sign ok-payment-method" title="Guardar"></span>
                                        <span @click="deleteVariant(variant.id)" class="glyphicon glyphicon-minus-sign delete-product" title="Borrar"></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div v-if="newVariants.length>0">
                        <label>Nuevas variantes</label>
                        <table class="col-md-12 newVariantTable">
                            <tr>
                                <th class="col-md-9"><span>ATRIBUTOS</span></th>
                                <th class="col-md-2"><span>STOCK</span></th>
                                <th class="col-md-1"><span></span></th>
                            </tr>
                            <tr v-for="(variant,index) in newVariants" :key='index'>
                                <td class="col-md-9">
                                    <span>{{listAtts(variant.attributes)}}</span>
                                </td>
                                <td class="col-md-2">
                                    <input type="number" class="form-control stockbox" v-model="variant.stock">
                                </td>
                                <td class="col-md-1">
                                    <span @click="deleteNewVar(variant)" class="glyphicon glyphicon-minus-sign delete-product" title="Borrar"></span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            -->

            <variants v-if="showVariantModal"
                :prod_id="productId"
                :linked_atts="getLinkedAtts()"
                :target="target"
                v-on:closemodal="showVariantModal=false"
                v-on:newVariant="variantNew"
                v-on:reload="reloadVariants"
                v-on:linkgroup="attGroupUpdate"
                v-on:unlinkgroup="attGroupRemove"
                v-on:updateAtts="attGroupUpdate"
            />
        </div>
    </div>
</template>

<script>
import Variants from './Attributes-modal.vue'
import { mapState } from 'vuex'
import currency from '../../global/CurrencyInput.vue';
import Treeselect from '@riophae/vue-treeselect'
import moment from 'moment';
import uploadimage from "../../general/Upload-image.vue";

export default {
    props: ['productId'],
    components: {
        Treeselect,
        Variants,
        uploadimage,
        currency
    },
    data() {
    return {
        config: {
            ecommerce: false
        },
        activeTab: 0,
        loading:true,
        showVariantModal:false,
        target:'all',
        disabledsave: 0,
        errors: {},
        product: {
            id: null,
            name: '',
            code: null,
            barcode: null,
            dispatch_code: null,
            stock_critical: 0,
            stock_minimum: 0,
            stock_initial: 0,
            unit: 'U',
            base_price: 0,
            iva: '21',
            prov_linked: [],
            type: 'PRODUCT',
            brand_id: null,
            prices: {},
            ecom_active: true,
            description:'',
            manufacturer_code:null,
            currency:'ARS',
            exchange_rate:0,
            cat_linked: [],
            var_linked:[],
            vars_new:[],
            images: [],
            setimagesid: [],
            atts_linked: [],
            editable:false,
            priceUpd:[]
        },
        variantList:[],
        newVariants:[],
        attGroups:[],
        stockByWarehouse:[],
        stockTotal:0,
        stockCurrent:0,
        stockCurrentWarehouse:'',
        stockLoaded:false,
        title:'',
        initial:true,
        providersList:[],
        pricesList:[],
        categoriesList:[],
        pricelistToEdit:null,
        valueOverCost:0,
    }
    },
    created() {
        this.$store.dispatch('brands/getBrands')
    },
    mounted() {
        this.loadCategories();
        this.loadProviders();
        this.loadPriceLists();
        this.getEditConfig();
        if (this.productId!=null) {
            this.title="Editar producto";
            this.initial=false;
            this.loadVariants();
            this.setForEdit(this.productId);
        } else {
            this.title="Nuevo producto";
            this.loading=false;
        }
    },
    methods: {
        setimages(value) {
            this.product.setimagesid = value;
        },
        fetchData(url, onSuccess) {
            return this.$http.get(url)
                .then((response) => {
                    if (response.status == 200) {
                        onSuccess(response.data.data);
                    }
                })
                .catch((error) => {
                    console.error('error: ' + error);
                });
        },
        getEditConfig() {
            this.fetchData("/api/products/getEditConfig", (data) => {
                this.config = data;
            });
        },
        getHexa(field){
            let data = JSON.parse(field);
            return 'background-color: ' + data.code + ';';
        },
        openAttsModal(){
            this.target='all';
            this.showVariantModal=true;
        },
        openVariantsModal(){
            this.target='product';
            this.showVariantModal=true;
        },
        changeCurrency(coin){
            this.product.currency = coin;
        },
        prepareSend() {
            this.errors = this.validateProduct();
            if (Object.keys(this.errors).length > 0) {
                this.goToFirstError();
                return;
            }
            if (this.product.barcode !== null) {
                this.getProductByBarcode(this.product.barcode);
                return;
            }
            this.updateProduct();
        },
        validateProduct() {
            const errors = {};
            if (!this.product.name || !String(this.product.name).trim()) {
                errors.name = 'El nombre es obligatorio';
            }
            if (this.$permitsAny(['PRODUCTO_CAMBIAR_PRECIO_COSTO']) && !(parseFloat(this.product.base_price) > 0)) {
                errors.base_price = 'El costo debe ser mayor a cero';
            }
            this.pricesList.forEach((list) => {
                if (isNaN(parseFloat(this.product.prices[list.id]))) {
                    errors['price_' + list.id] = 'Ingresá un precio para esta lista';
                }
            });
            return errors;
        },
        goToFirstError() {
            const firstError = Object.keys(this.errors)[0];
            this.activeTab = firstError === 'name' ? 0 : 1;
            this.$nextTick(() => {
                const field = this.$el.querySelector('.is-invalid, .field-invalid');
                if (field) {
                    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        clearError(field) {
            if (this.errors[field]) {
                this.$delete(this.errors, field);
            }
        },
        handleInput() {
            if (!this.product.barcode) {
                this.product.barcode = null;
            }
        },
        getProductByBarcode(barcode) {
            this.$http.get('api/products/getProductByBarcode/' + barcode)
                .then(async (response) => {
                    if (response.data.success == true) {
                        if (response.data.data.id == this.product.id) {
                            this.updateProduct();
                        } else {
                            const ok = await this.$confirm(
                                "El codigo de barras ya esta en uso en " + response.data.data.name + ". Atencion: si lo comparte, al escanearlo en el Punto de Venta siempre se traera el producto mas antiguo con ese codigo. ¿Desea compartir el mismo codigo de barras para diferentes productos?",
                                { title: 'Codigo de barras en uso', okText: 'Compartir codigo' }
                            );
                            if (ok) {
                                this.updateProduct();
                            } else {
                                alert('Ingrese un codigo de barras que no se este utilizando');
                            }
                        }
                    } else {
                        this.updateProduct();
                    }
                })
                .catch((error) => {
                    console.error('error: ' + error);
                    alert('No se pudo verificar el codigo de barras. Intente nuevamente.');
                });
        },
        updateProduct() {
            this.loading = true;
            this.product.vars_new = this.newVariants;
            this.product.atts_linked = this.attGroups;
            const url = this.productId == null ? '/api/products/add' : '/api/products/edit/' + this.productId;
            this.$http.post(url, this.product)
                .then((response) => {
                    if (response && response.data && response.data.code === 201) {
                        // El interceptor de axios ya disparó el toast de éxito.
                        this.$router.push('/inventario/productos');
                    }
                })
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        listAtts(attributes) {
            return attributes.map((att) => att.name).join(' ');
        },
        setForEdit(id) {
            this.$http.get("/api/products/view/" + id)
                .then((response) => {
                    if (response.status == 200) {
                        const result = response.data.data;
                        this.product.ecom_active = result.ecom_active;
                        this.product.id = result.id;
                        this.product.name = result.name;
                        this.product.code = result.code;
                        this.product.barcode = result.barcode;
                        this.product.dispatch_code = result.dispatch_code;
                        this.product.stock_critical = result.stock_critical;
                        this.product.stock_minimum = result.stock_minimum;
                        this.product.unit = result.unit;
                        this.product.base_price = result.base_price;
                        this.product.iva = result.iva;
                        this.product.prov_linked = result.prov_linked;
                        this.product.type = result.type;
                        this.product.brand_id = result.brand_id;
                        this.product.manufacturer_code = result.manufacturer_code;
                        this.product.description = result.description;
                        this.product.currency = result.currency;
                        this.product.exchange_rate = result.exchange_rate;
                        this.product.editable = result.editable;
                        this.product.prices = result.prices;
                        this.product.priceUpd = result.priceUpd;
                        this.product.cat_linked = result.cat_linked;
                        this.product.var_linked = result.var_linked;
                        this.product.images = result.images ?? [];
                        this.product.setimagesid = this.product.images.map((e) => e.id);

                        // El desglose de stock solo existe si el backend ya lo soporta
                        // (rama feature/variantes de qupro-be); si no viene, se oculta la UI.
                        this.stockByWarehouse = result.stock_by_warehouse ?? [];
                        this.stockTotal = result.stock_total ?? 0;
                        this.stockCurrent = result.stock_current ?? 0;
                        this.stockCurrentWarehouse = result.stock_current_warehouse ?? '';
                        this.stockLoaded = result.stock_current != null;

                        if (result.attribute_types != null) {
                            this.attGroups = result.attribute_types;
                        }
                    }
                })
                .catch((error) => {
                    console.error('error: ' + error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        variantNew(obj) {
            this.newVariants.push(obj);
        },
        deleteNewVar(variant) {
            const index = this.newVariants.indexOf(variant);
            if (index !== -1) {
                this.newVariants.splice(index, 1);
            }
        },
        deleteVariant(vid) {
            const index = this.variantList.findIndex((v) => v.id === vid);
            if (index !== -1) {
                this.variantList.splice(index, 1);
            }
            this.product.var_linked = this.variantList.map((v) => v.id);
            alert('Variante asignada para eliminación. Guarde el producto para efectuar los cambios.');
        },
        updateVariant(obj) {
            this.$http.post("/api/variants/updateVariant", obj)
                .then((response) => {
                    if (response.status == 200) {
                        this.loadVariants();
                    }
                })
                .catch((error) => {
                    console.error('error: ' + error);
                });
        },
        loadProviders() {
            this.fetchData("/api/providers/getProviders", (data) => {
                this.providersList = data.map((item) => {
                    item.label = item.name;
                    return item;
                });
            });
        },
        loadPriceLists() {
            this.fetchData("/api/priceslist/getPriceList", (data) => {
                this.pricesList = data;
            });
        },
        loadCategories() {
            this.fetchData("/api/categories/getCategoryTree", (data) => {
                this.categoriesList = data;
            });
        },
        suggestCode() {
            this.loading = true;
            this.fetchData("/api/products/newCode", (data) => {
                this.product.code = data;
            }).finally(() => {
                this.loading = false;
            });
        },
        attGroupRemove(id) {
            const index = this.attGroups.findIndex((g) => g.id === id);
            if (index !== -1) {
                this.attGroups.splice(index, 1);
            }
        },
        attGroupUpdate(data) {
            this.showVariantModal = false;
            this.attGroups = data;
        },
        getLinkedAtts() {
            const linked = [];
            this.attGroups.forEach((group) => {
                group.attributes.forEach((att) => {
                    linked.push(att);
                });
            });
            return linked;
        },
        loadVariants() {
            this.fetchData("/api/variants/getVariants/" + this.productId, (data) => {
                if (data) {
                    this.variantList = data;
                }
            });
        },
        reloadVariants(id) {
            this.newVariants.forEach((variant) => {
                const index = variant.attributes.findIndex((att) => att.id === id);
                if (index !== -1) {
                    variant.attributes.splice(index, 1);
                }
            });
            this.newVariants = this.newVariants.filter((variant) => variant.attributes.length > 0);
            this.loadVariants();
        },
        setPricelistToEdit(id){
            this.pricelistToEdit = id;
            this.valueOverCost = this.getEarningPercent(id);
        },
        getEarningPercent(id){
            const base = parseFloat(this.product.base_price);
            const price = parseFloat(this.product.prices[id]);
            if (!base || isNaN(price)) {
                return '0.00';
            }
            return (((price - base) * 100) / base).toFixed(2);
        },
        calculateIncrease(pl){
            this.product.prices[pl.id] = this.product.base_price + ((this.product.base_price * this.valueOverCost)/100);
            this.valueOverCost=0;
            this.pricelistToEdit=null;
        },
        getLastUpdate(id){
            if(moment(this.product.priceUpd[id]).isValid()){
                return moment(this.product.priceUpd[id]).format('DD/MM/YYYY');
            }else{
                return 'Nunca';
            }
        },
        cancelIncrease(){
            this.valueOverCost=0;
            this.pricelistToEdit=null;
        },
    },
    computed: {
        ...mapState('authUser',{
            authUser: state => state.authUser,
        }),
        ...mapState('brands',{
            brands: state => state.brands,
        }),
        isService() {
            return this.product.type === 'SERVICE';
        }
    }

}
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
